import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fieldProps", "proFieldProps"];
import React from 'react';
import ProField from "../Field";
/**
 * 评分组件
 *
 * @param
 */
import { jsx as _jsx } from "react/jsx-runtime";
var ProFormRate = function ProFormRate(_ref, ref) {
  var fieldProps = _ref.fieldProps,
    proFieldProps = _ref.proFieldProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ProField, _objectSpread({
    valueType: "rate",
    fieldProps: fieldProps,
    ref: ref,
    proFieldProps: proFieldProps,
    filedConfig: {
      ignoreWidth: true
    }
  }, rest));
};
export default /*#__PURE__*/React.forwardRef(ProFormRate);